import { Injectable } from '@angular/core';
import { AuthHttp } from '../http/http.service';
import { environment } from '../../../environments/environment';
import { asError, requestWithResponse } from '../http/request-with-response';
@Injectable()
export class InfoconfiguracionService {
  constructor(private readonly http: AuthHttp) {}

  update(empresa_id: any, id_infoconfiguracion: any, value: any) {
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/infoconfiguracion/update`, { id_infoconfiguracion, value }),
      () => undefined,
      asError);
  }

  getValue(empresa_id: any, id_infoconfiguracion: any) {
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/infoconfiguracion/value`, { id_infoconfiguracion }),
      () => undefined,
      asError);
  }
  getConfiguraciones(empresa_id: any) {
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/infoconfiguraciones/values`, { empresa: empresa_id }),
      () => undefined,
      () => new Error('No se han podido obtener las configuraciones'));
  }

  updateTienda(empresa_id: any, id_infoconfiguracion: any, value: any, tienda: any) {
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/infoconfiguracion/update`, { id_infoconfiguracion, value, tienda }),
      () => undefined,
      () => new Error('No se ha podido actualizar la configuración de la tienda'));
  }
  getValueTienda(empresa_id: any, id_infoconfiguracion: any, tienda: any) {
    return requestWithResponse(this.http.post(`${environment.apiURLs.private}/empresa/${empresa_id}/infoconfiguracion/value`, { id_infoconfiguracion, tienda }),
      () => undefined,
      () => new Error('No se ha podido actualizar la configuración'));
  }
}
